export type Role = 'ultraadmin' | 'superadmin' | 'admin' | 'director' | 'hr' | 'teacher' | 'engineer' | 'partner'

export const ROLE_LABELS: Record<Role, string> = {
  ultraadmin: 'Ultraadmin',
  superadmin: 'Superadmin',
  admin: 'Admin',
  director: 'Direktor',
  hr: 'HR',
  teacher: 'Lehrperson',
  engineer: 'Engineer',
  partner: 'Partner',
}

export const ROLE_SHORT: Record<Role, string> = {
  ultraadmin: 'UA',
  superadmin: 'SA',
  admin: 'AD',
  director: 'DI',
  hr: 'HR',
  teacher: 'LP',
  engineer: 'EN',
  partner: 'PA',
}

export const ROLE_PILL_HEX: Record<Role, string> = {
  ultraadmin: '#dc2626',
  superadmin: '#7c3aed',
  admin: '#2563eb',
  director: '#4f46e5',
  hr: '#ca8a04',
  teacher: '#64748b',
  engineer: '#ea580c',
  partner: '#0d9488',
}

export const ROLE_COLORS: Record<Role, string> = {
  ultraadmin: 'bg-red-100 text-red-800',
  superadmin: 'bg-purple-100 text-purple-800',
  admin: 'bg-blue-100 text-blue-800',
  director: 'bg-indigo-100 text-indigo-800',
  hr: 'bg-yellow-100 text-yellow-800',
  teacher: 'bg-green-100 text-green-800',
  engineer: 'bg-orange-100 text-orange-800',
  partner: 'bg-teal-100 text-teal-800',
}

export const ROLE_PERMISSIONS: Record<Role, string[]> = {
  ultraadmin: ['create_school', 'create_superadmin'],
  superadmin: ['all'],
  admin: ['manage_substitutions', 'manage_teachers'],
  director: ['view_substitution_requests', 'approve_substitution', 'request_documents'],
  hr: ['view_statistics'],
  teacher: ['manage_own_substitutions'],
  engineer: ['dynamic_scopes'],
  partner: ['create_school', 'create_superadmin', 'partner.billing.read'],
}
